import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import { Dialog, Slide, Button, DialogTitle, DialogContent, DialogActions, Snackbar } from '@material-ui/core';
import Remitente from '../../Catalogos/clientes/remitentes/Remitente';
import Destinatario from '../../Catalogos/clientes/destinatarios/Destinatario';
import PreguiaDetalles from './PreguiaDetalles';
import { AuthContext } from "../../../context/authContext";
import './Preguia.css'
import AccionesPreGuia from '../../../components/accionesPreguia/AccionesPreguia';
import ACCESS from '../../../ACCESS';
// import {FormGroup} from '../../form/FormOpsV2'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class Preguia extends FormComponent {
  static contextType = AuthContext

  constructor(props) {
    super(props)
    this.actions = React.createRef();
    this.formRems = null;
    this.formDests = null;
    this.formClis = null;
    this.orignesDestinos = [];
    this.currentSucursal = null;
  }

  componentDidMount() {
    this.initial_data = true;
    const { user } = this.context;
    this.FormConfig(
      { defaultUrl: 'preguia/one', saveUrl: 'preguia/save', backUrl: '/Preguias' },
      new Form([
        Form.Field('hidden', 'id', '', null, [], 0),
        // Form.Field('select', 'id_origen_destino', 'Origen / Destino', '', [Validators.required], 6),
        Form.Field('select', 'origen_id_sucursal', 'Origen',  user.id_sucursal || '', [Validators.required], 7),
        // Form.Field('select', 'destino_id_sucursal', 'Destino', '', [Validators.required], 4),
        Form.Field('date-hour', 'pg_fecha_reporte', 'Fecha y hora de reporte', new Date(), [Validators.required], 5, [], [], [], false, true),
        Form.Field('text', 'pg_receptor', 'Nombre de quien solicita recolección', '', [Validators.required], 12),
        Form.Section('PROGRAMAR RECOLECCIÓN'),
        Form.Field('date-hour', 'pg_pro_fecha', 'Fecha y hora', new Date(), [Validators.required], 12),
        Form.Section('DATOS DEL CLIENTE'),
        // Form.Field('hidden', 'pg_cliente_id', '', '', [Validators.required], 4),
        Form.Field('select', 'pg_cliente_es', 'El cliente es', '', [Validators.required], 6, [{ Value: 1, Label: 'Remitente' }, { Value: 2, Label: 'Destinatario' }]),
        Form.Space(6),
        Form.Field('hidden', 'id_cliente_main', '', '', [Validators.required], 0),
        Form.Field('autocomplete', 'cliente', 'Clave', '', [Validators.required], 2),
        Form.Field('autocomplete', 'cliente_rsocial', 'Razón social', '', [], 6),
        Form.Field('autocomplete', 'cliente_rfc', 'R.F.C.', '', [], 4),
        Form.Field('text', 'cliente_telefono', 'Teléfono', '', [], 3, [], [], [], false, true),
        Form.Field('text', 'cliente_domicilio', 'Domicilio', '', [], 6, [], [], [], false, true),
        Form.Field('text', 'cliente_cp', 'C.P.', '', [Validators.required], 3, [], [], [], false, true),
        Form.Field('select', 'cliente_id_estado', 'Estado', '', [], 4, [], [], [], false, true),
        Form.Field('select', 'cliente_id_ciudad', 'Ciudad', '', [], 4, [], [], [], false, true),
        Form.Field('autocomplete', 'cliente_id_colonia', 'Colonia', '', [], 4, [], [], [], false, true),
        Form.Section('Correo electrónico para enviar seguimiento', 2, [], [], [], false, true),
        Form.Field('text', 'pg_seg_email', 'Correo electrónico', '', [], 4),
        Form.Field('text', 'pg_seg_cc1', 'C.C.', '', [], 4, [], [], [], false, false),
        Form.Field('text', 'pg_seg_cc2', 'C.C.', '', [], 4),
        Form.Section('DATOS DEL REMITENTE'),
        Form.Space(10),
        Form.Button(3000, 'Nuevo', 2),
        Form.Field('hidden', 'id_cliente_rem', '', '', [Validators.required], 0),
        Form.Field('autocomplete', 'cliente_rems', 'Remitente', '', [Validators.required], 12),
        // Form.Field('autocomplete', 'cliente_rems_nombre', 'Remitente', '', [], 6),
        Form.Field('text', 'cliente_rems_telefono', 'Teléfono', '', [], 4),
        Form.Field('text', 'cliente_rems_domicilio', 'Domicilio', '', [], 4),
        Form.Field('text', 'cliente_rems_cp', 'C.P.', '', [Validators.required], 4),
        Form.Field('autocomplete', 'cliente_rems_id_colonia', 'Colonia', '', [], 4),
        Form.Field('select', 'cliente_rems_estado', 'Estado', '', [], 4),
        Form.Field('select', 'cliente_rems_id_ciudad', 'Ciudad', '', [], 4),
        Form.Section('DATOS DEL DESTINATARIO'),
        Form.Space(10),
        Form.Button(4000, 'Nuevo', 2),
        Form.Field('hidden', 'id_cliente_dest', '', '', [Validators.required], 0),
        Form.Field('autocomplete', 'cliente_dests', 'Destinatario', '', [Validators.required], 12),
        // Form.Field('autocomplete', 'cliente_dests_nombre', 'Destinatario', '', [], 6),
        Form.Field('text', 'cliente_dests_telefono', 'Teléfono', '', [], 4),
        Form.Field('text', 'cliente_dests_domicilio', 'Domicilio', '', [], 4),
        Form.Field('text', 'cliente_dests_cp', 'C.P.', '', [Validators.required], 4),
        Form.Field('autocomplete', 'cliente_dests_id_colonia', 'Colonia', '', [], 4),
        Form.Field('select', 'cliente_dests_estado', 'Estado', '', [], 4),
        Form.Field('select', 'cliente_dests_id_ciudad', 'Ciudad', '', [], 4),
      ], ['Detalle'], 'Preguia'), this.formData
    )
    if (this.props.match.params.id) {
      this.LoadPreds()
    }
  }

  formData = async (form) => {
    // console.log('asd')
    var Res = await Http.get(`preguia/form?${(this.formRems) ? `r=${this.formRems}` : ''}${(this.formRemsId) ? `&r_id=${this.formRemsId}` : ''}${(this.formRemsClve) ? `&rclve=${this.formRemsClve}` : ''}${(this.formDests) ? `&d=${this.formDests}` : ''}${(this.formDestsClve) ? `&dclve=${this.formDestsClve}` : ''}${(this.formDestsId) ? `&d_id=${this.formDestsId}` : ''}${(this.formClis) ? `&c=${this.formClis}` : ''}${(this.formCliEst) ? `&ce=${this.formCliEst}` : ''}${(this.formCliRemEst) ? `&cre=${this.formCliRemEst}` : ''}${(this.formCliDestEst) ? `&cde=${this.formCliDestEst}` : ''}${(this.formCliCp) ? `&ccp=${this.formCliCp}` : ''}${(this.formCliRemCp) ? `&crcp=${this.formCliRemCp}` : ''}${(this.formCliDesCp) ? `&cdcp=${this.formCliDesCp}` : ''}${(this.formCliClv) ? `&ccvle=${this.formCliClv}` : ''}${(this.formClirfc) ? `&crfc=${this.formClirfc}` : ''}${(this.formCliId) ? `&clid=${this.formCliId}` : ''}${(this.initial_data) ? `&initial_data=${this.initial_data}` : ''}`);
    if (this.formRems) {
      this.formRems = null;
    }
    if (this.formRemsId) {
      this.formRemsId = null;
    }
    if (this.formRemsClve) {
      this.formRemsClve = null;
    }
    if (this.formDestsId) {
      this.formDestsId = null;
    }
    if (this.formDests) {
      this.formDests = null;
    }
    if (this.formClis) {
      this.formClis = null;
    }
    if (this.formCliEst) {
      this.formCliEst = null;
    }
    if (this.formCliRemEst) {
      this.formCliRemEst = null;
    }
    if (this.formCliDestEst) {
      this.formCliDestEst = null;
    }
    if (this.formCliCp) {
      this.formCliCp = null;
    }
    if (this.formCliRemCp) {
      this.formCliRemCp = null;
    }
    if (this.formCliDesCp) {
      this.formCliDesCp = null;
    }
    if (this.formCliClv) {
      this.formCliClv = null;
    }
    if (this.formClirfc) {
      this.formClirfc = null;
    }
    /* if (this.formCliId) {
      this.formCliId = null;
    } */
    
    // var Res = await Http.get('preguia/form');
    if (!Res.error) {
      let newForm = form;
      if (Res.data.ods) {
        this.orignesDestinos = Res.data.ods;
        if (this.initial_data) {
          const { user } = this.context;
          this.origenChange({ Value: user.id_sucursal })
        }
        console.log(Res.data.ods);
        newForm = Form.FieldOptions(form, 'origen_id_sucursal', Res.data.ods, 'id', 'label');
      }
      if (Res.data.estados) {
        newForm = Form.FieldOptions(form, 'cliente_id_estado', Res.data.estados, 'id', 'estado');
        newForm = Form.FieldOptions(form, 'cliente_rems_estado', Res.data.estados, 'id', 'estado');
        newForm = Form.FieldOptions(form, 'cliente_dests_estado', Res.data.estados, 'id', 'estado');
      }
      if (Res.data.remitentes) {
        // newForm = Form.FieldOptions(newForm, 'cliente_rems_nombre', Res.data.remitentes, 'id', 'cliente_rems_nombre');
        newForm = Form.FieldOptions(newForm, 'cliente_rems', Res.data.remitentes, 'id', 'cliente_rems');
      }
      if (Res.data.destinatarios) {
        newForm = Form.FieldOptions(newForm, 'cliente_dests', Res.data.destinatarios, 'id', 'cliente_dests');
        // newForm = Form.FieldOptions(newForm, 'cliente_dests_nombre', Res.data.destinatarios, 'id', 'cliente_dests_nombre');
      }
      if (Res.data.clientes) {
        newForm = Form.FieldOptions(newForm, 'cliente_rsocial', Res.data.clientes, 'id', 'cliente_rsocial');
        newForm = Form.FieldOptions(newForm, 'cliente', Res.data.clientes, 'id', 'cliente');
        newForm = Form.FieldOptions(newForm, 'cliente_rfc', Res.data.clientes, 'id', 'cliente_rfc');
        this.formCliClv = null;
        this.formClis = null;
      }
      if (Res.data.cli_direccion) {
        newForm = Form.FieldOptions(newForm, 'cliente_id_ciudad', Res.data.cli_direccion.ciudades, 'id', 'ciudad');
        newForm = Form.FieldOptions(newForm, 'cliente_id_colonia', Res.data.cli_direccion.colonias, 'id', 'colonia');
        newForm = Form.Patch(newForm, { cliente_id_estado: Res.data.cli_direccion.estado.id, cliente_id_ciudad: Res.data.cli_direccion.ciudad.id });
      }
      if (Res.data.rem_direccion) {
        newForm = Form.FieldOptions(newForm, 'cliente_rems_id_ciudad', Res.data.rem_direccion.ciudades, 'id', 'ciudad');
        newForm = Form.FieldOptions(newForm, 'cliente_rems_id_colonia', Res.data.rem_direccion.colonias, 'id', 'colonia');
        newForm = Form.Patch(newForm, { cliente_rems_estado: Res.data.rem_direccion.estado.id, cliente_rems_id_ciudad: Res.data.rem_direccion.ciudad.id });
      }
      if (Res.data.dest_direccion) {
        newForm = Form.FieldOptions(newForm, 'cliente_dests_id_ciudad', Res.data.dest_direccion.ciudades, 'id', 'ciudad');
        newForm = Form.FieldOptions(newForm, 'cliente_dests_id_colonia', Res.data.dest_direccion.colonias, 'id', 'colonia');
        newForm = Form.Patch(newForm, { cliente_dests_estado: Res.data.dest_direccion.estado.id, cliente_dests_id_ciudad: Res.data.dest_direccion.ciudad.id });
      }
      if (Res.data.rem_ciudades) { 
        newForm = Form.FieldOptions(newForm, 'cliente_rems_id_ciudad', Res.data.rem_ciudades, 'id', 'ciudad');
      }
      if (Res.data.dest_ciudades) { 
        newForm = Form.FieldOptions(newForm, 'cliente_dests_id_ciudad', Res.data.dest_ciudades, 'id', 'ciudad');
      }

      newForm = Form.ValueChange(newForm, {
        // cliente_rems_nombre: async (field) => { await this.remitenteChange(field, 'formRems') },
        cliente_rems: async (field) => { ((field.ValueAt && field.ValueAt.length > 1) || (field.Value && field.Value.length > 0)) && await this.remitenteChange(field, 'formRems') },
        // cliente_dests_nombre: async (field) => { await this.destinatarioChange(field, 'formDests') },
        cliente_dests:  async (field) => { ((field.ValueAt && field.ValueAt.length > 1) || (field.Value && field.Value.length > 0)) && await this.destinatarioChange(field, 'formDests') },
        cliente: async (field) => { await this.clienteChange(field, 'formCliClv') },
        cliente_rsocial: async (field) => { await this.clienteChange(field, 'formClis') },
        cliente_rfc: async (field) => { await this.clienteChange(field, 'formClirfc') },
        cliente_cp: this.cliCpChange,
        cliente_rems_cp: this.cliRemCpChange,
        cliente_dests_cp: this.cliDestCpChange,
        cliente_id_estado: this.cliEstadoChange,
        // cliente_rems: this.cliEstadoChange,
        cliente_rems_estado: this.cliRemEstadoChange,
        cliente_dests_estado: this.cliDestEstadoChange,
        origen_id_sucursal: this.origenChange,
        pg_fecha_reporte: this.fechaRecoleccionChange,
      });
      if (this.initial_data) {
        this.initial_data = null;
      }
      return newForm;
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.id !== prevProps.match.params.id) {
      this.LoadPreds(this.props.match.params.id);
    }
  }

  LoadPreds = async (predId = null) => {
    let id = predId ? predId : this.props.match.params.id;
    let Res = await Http.get(`preguia/one/${id}`);
    const { user, hasAccess } = this.context;
    let { formDisabled  = false } = this.state;
    if (!Res.error) {
      const modo = 'edit';
      const formData = this.state.FormData;
      formData.Title = `Preguia: ${Res.data.id}`
      if (hasAccess(ACCESS.PREGUIA.EDITAR_PREGUIAS_CREADAS_POR_EL_USUARIO) || Res.data.pg_estado !== 1) {
        if (Res.data.id_user !== user.id || Res.data.pg_estado !== 1) {
          for (const [index] of formData.Fields.entries()) {
            formData.Fields[index].Disabled = true;
            formDisabled = true;
          }
        }
      }
      await this.clienteChange({ Value: Res.data.id_cliente })
      await this.remitenteChange({ Value: Res.data.id_cliente_rem })
      await this.destinatarioChange({ Value: Res.data.id_cliente_dest })
      this.setState({ FormData: Form.Patch(formData, Res.data, true), preguia: Res.data, formDisabled, pg_estado: Res.data.pg_estado, modo });
    }
  }

  fechaRecoleccionChange = async (field) => {
    const errors = [];
    const warnings = [];
    try {
      console.log(this.currentSucursal)
      const currentSucursalStartTimeSplit = this.currentSucursal.sucursal_hora_apertura.split(':');
      const currentSucursalStartTime = new Date();
      currentSucursalStartTime.setHours(currentSucursalStartTimeSplit[0], currentSucursalStartTimeSplit[1], 0);

      const currentSucursalEndTimeSplit = this.currentSucursal.sucursal_hora_cierre.split(':');
      const currentSucursalEndTime = new Date();
      currentSucursalEndTime.setHours(currentSucursalEndTimeSplit[0], currentSucursalEndTimeSplit[1], 0);

      const currentRecoleccionTime = new Date();
      //currentRecoleccionTime.setHours(field.Value.getHours(), field.Value.getMinutes(), field.Value.getSeconds());

      // console.log(currentRecoleccionTime, currentSucursalStartTime, currentSucursalEndTime)
      if (currentRecoleccionTime <= currentSucursalStartTime) {
        errors.push('La hora debe ser mayor a la hora de apertura de la sucursal de origen.');
      }

      if (currentRecoleccionTime >= currentSucursalEndTime) {
        warnings.push('La hora es fuera de horario, se enviará un correo de autorización.');
      }

      // console.log(errors, warnings)
      let newForm = Form.SetInvalidField(this.state.FormData, field.Name, errors)
      newForm = Form.SetWarningField(newForm, field.Name, warnings)
      this.setState({ FormData: newForm });
      // Form.SetWarningField(this.state.FormData, field.Name, warnings);
    } catch (error) {
      console.log(error);
    }
  }

  origenChange = async (field) => {
    this.currentSucursal = this.orignesDestinos.find(ods => ods.id === field.Value);
    this.fechaRecoleccionChange({ Name: 'pg_fecha_reporte' });
  }

  cliCpChange = async (field) => {
    if (field.Value.length === 5) {
      this.formCliCp = field.Value;
      this.setState({ FormData: await this.formData(this.state.FormData) });
    }
  }

  cliRemCpChange = async (field) => {
    if (field.Value.length === 5) {
      this.formCliRemCp = field.Value;
      this.setState({ FormData: await this.formData(this.state.FormData) });
    }
  }

  cliDestCpChange = async (field) => {
    if (field.Value.length === 5) {
      this.formCliDesCp = field.Value;
      this.setState({ FormData: await this.formData(this.state.FormData) });
    }
  }

  cliEstadoChange = async (field) => {
    this.formCliEst = field.Value;
    this.setState({ FormData: await this.formData(this.state.FormData) })
  }

  cliRemEstadoChange = async (field) => {
    // console.log('estado rem change')
    this.formCliRemEst = field.Value;
    this.setState({ FormData: await this.formData(this.state.FormData) })
  }

  cliDestEstadoChange = async (field) => {
    this.formCliDestEst = field.Value;
    this.setState({ FormData: await this.formData(this.state.FormData) })
  }

  clienteChange = async (field, variable) => {
    if (field.Value) {
      let Res = await Http.get(`cliente/one/${field.Value}`);
      if (!Res.error) {
        const { id, cliente_domicilio, cliente_telefono,
          cliente_cp, Estado, Ciudad, Colonia, cliente_estado } = Res.data;
        if (cliente_estado === 2) {
          return;
        }
        this.formCliCp = cliente_cp;
        this.formCliId = id;
        const formData = await this.formData(this.state.FormData)

        this.setState({ FormData: Form.Patch(formData, {
          'id_cliente_main': id,
          'cliente': id+'',
          'cliente_rsocial': id+'',
          'cliente_rfc': id+'',
          'cliente_telefono': cliente_telefono,
          'cliente_domicilio': cliente_domicilio,
          'cliente_cp': cliente_cp,
          'cliente_id_estado': Estado.id,
          'cliente_id_ciudad': Ciudad.id,
          'cliente_id_colonia': Colonia.id+'',
        }, false) });
      }
    }
    else {
      this[variable] = field.ValueAt;
      this.setState({ FormData: await this.formData(this.state.FormData) })
    }
  }

  remitenteChange = async (field, variable) => {
    if (field.Value) {
      let Res = await Http.get(`cliente-remitente/one/${field.Value}`);
      if (!Res.error) {
        const { id, cliente_rems_cp, Colonia  } = Res.data;
        this.formRemsId = id;
        await this.cliRemCpChange({ Value: cliente_rems_cp+''})
        const formData = await this.formData(this.state.FormData)
        delete Res.data.id
        const newForm = Form.Patch(formData, {
          ...Res.data,
          id_cliente_rem: id,
          // cliente_rems_nombre: id+'',
          cliente_rems: id+'',
          cliente_rems_id_colonia: Colonia.id+''
        }, false)
        this.setState({ FormData: newForm });
      }
    }
    else {
      this.formRems = field.ValueAt;
      // this.formRemsClve = field.ValueAt;
      this[variable] = field.ValueAt;
      this.setState({ FormData: await this.formData(this.state.FormData) })
    }
  }

  destinatarioChange = async (field, variable) => {
    if (field.Value) {
      let Res = await Http.get(`cliente-destinatario/one/${field.Value}`);
      if (!Res.error) {
        const { id, cliente_dests_cp, Colonia } = Res.data;
        this.formDestsId = id;
        await this.cliDestCpChange({ Value: cliente_dests_cp+'' });
        const formData = await this.formData(this.state.FormData)
        delete Res.data.id
        const newForm = Form.Patch(formData, {
          ...Res.data,
          id_cliente_dest: id,
          // cliente_dests_nombre: id+'',
          cliente_dests: id+'',
          cliente_dests_id_colonia: Colonia.id+''
        }, false)
        this.setState({ FormData: newForm });
      }
    }
    else {
      this.formDests = field.ValueAt;
      // this.formDestsClve = field.ValueAt;
      this[variable] = field.ValueAt;
      this.setState({ FormData: await this.formData(this.state.FormData) })
    }
  }

  onSubmit = async (i, vals) => {
    let idCliente = Form.GetFieldProp(this.state.FormData, 'id_cliente_main', 'Value');
    if (i === 3000) {
      if (idCliente.length < 1) return;
      // console.log('add rem')
      this.setState({ addRemOpen: true, idCliente })
      return;
    }
    else if (i === 4000) {
      if (idCliente.length < 1) return;
      // console.log('add dest')
      this.setState({ addDestOpen: true, idCliente })
      return;
    }
    else {
      this.preguiaVals = vals;
      this.setState({ detalleOpen: true })
    }
  }

  submitDetalles = async (detalles) => {
    // if (!formDisabled) {
      let errormsg = false;
      if (!detalles.productos) {
        detalles.productos = detalles.paquetes.map(paq => ({
          cantidad: paq.pq_cantidad,
          peso: paq.pq_peso,
          descripcion: paq.pq_descripcion,
          id_unidad: paq.pq_id_unidad,
          id_producto: paq.pq_id_producto,
        }))
      }
      for (const produc of detalles.productos) {
        console.log(produc)
        if (!(produc.id_unidad || produc.clave_unidad) || !(produc.id_producto || produc.producto_clave) || produc.id_unidad === '' || produc.id_producto === '') {
          errormsg = 'Checar los productos y unidades';
        }
      }
      for (const paquete of detalles.paquetes) {
        if (!paquete.pq_id_unidad || !paquete.pq_id_producto || paquete.pq_id_unidad === '' || paquete.pq_id_producto === '') {
          errormsg = 'Checar los productos y unidades';
        }
      }
      if (errormsg) {
        this.setState({ loading: false, sbMsg: errormsg, sbOpen: true });
      } else {
        const Res = await Http.post(`preguia/save-preguia`, { preguia: this.preguiaVals, detalles });
        if (!Res.error) {
          this.setState({ loading: false, sbMsg: 'Guardado', sbOpen: true, FormData: Form.Reset(this.state.FormData), detalleOpen: false });
          await this.actions.current.handlePrintClick(Res.data.id);
        }
        else {
          this.setState({ loading: false, sbMsg: 'Error al guardar', sbOpen: true });
        }
      }
    // } else {
      // this.props.history.push(`/Preguias/Todas`)
    // }
  }

  addRemClose = async (data) => {
    if (data.id) {
      this.remitenteChange({ Value: data.id });
    }
    this.setState({ addRemOpen: false });
    return;
  }

  addDestClose = async (data) => {
    if (data.id) {
      this.destinatarioChange({ Value: data.id  });
    }
    this.setState({ addDestOpen: false });
    return;
  }

  detallesClose = () => {
    this.setState({ detalleOpen: false })
  }

  handleSbClaveClose = () => {
    this.setState({ clavesbOpen: false })
  }

  render() {
    const { addRemOpen, addDestOpen, detalleOpen, idCliente, fdOpen, fdFolio, correctClave, clavesbOpen, preguia, formDisabled, pg_estado, modo } = this.state;
    return (
      <div>

        <AccionesPreGuia
          {...this.props}
          ref={this.actions}
          pg_estado={pg_estado} 
          modo={modo} 
          onRedocumentar={this.modoRedocumentacion} 
          onSelectFolio={this.onSelectFolio} 
        />

        <this.FormRender />

        <div>
          <Dialog onClose={this.addRemClose} open={addRemOpen ? addRemOpen : false} fullWidth={true} maxWidth={'xl'}>
            <DialogTitle onClose={this.addRemClose}>
              Nuevo Remitente
            </DialogTitle>
            <DialogContent dividers>
              <Remitente onSave={this.addRemClose} back={false} cliente={idCliente ? idCliente : null}></Remitente>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.addRemClose}>CANCELAR</Button>
            </DialogActions>
          </Dialog>
        </div>

        <div>
          <Dialog onClose={this.addDestClose} open={addDestOpen ? addDestOpen : false} fullWidth={true} maxWidth={'xl'}>
            <DialogTitle onClose={this.addDestClose}>
              Nuevo Destinatario
            </DialogTitle>
            <DialogContent dividers>
              <Destinatario onSave={this.addDestClose} back={false} cliente={idCliente ? idCliente : null}></Destinatario>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.addDestClose}>CANCELAR</Button>
            </DialogActions>
          </Dialog>
        </div>

        <div>
          <Dialog fullScreen open={detalleOpen ? detalleOpen : false} onClose={this.detallesClose} TransitionComponent={Transition}>
            <div style={{ textAlign: 'right' }}>
              <Button onClick={this.detallesClose}>REGRESAR</Button>
            </div>
            <div>
              <PreguiaDetalles onSave={this.submitDetalles} preguia={preguia} formDisabled={formDisabled} />
            </div>
          </Dialog>
        </div>

        <div>
          <Dialog onClose={() => { this.setState({ fdOpen: false }) }} open={fdOpen ? fdOpen : false}>
            <DialogTitle onClose={() => { this.setState({ fdOpen: false }) }}>
              Folio de preguía: <span style={{fontWeight: 'bolder'}}>{fdFolio}</span>
            </DialogTitle>
            <DialogActions>
              <Button autoFocus onClick={() => { this.setState({ fdOpen: false }) }} color="primary">
                Aceptar
              </Button>
            </DialogActions>
          </Dialog>
        </div>

        <Snackbar open={clavesbOpen || false} autoHideDuration={6000} onClose={this.handleSbClaveClose} message={correctClave ? "Clave Correcta" : "Clave Incorrecta Verifiquelo de nuevo"}>
        </Snackbar>
      </div>
    )
  }
}

export default withRouter(Preguia)
